import React from 'react'
import ReactMarkdown from "react-markdown";
import styled, { withTheme } from 'styled-components'

const TextWrapper = styled.div`
    margin-left: 100px;
    margin: ${props => props.margins};
    display: grid; 
    grid-template-columns: 30px 1fr;
    z-index: 200;
    position: relative;

    p {
        margin:0;
        margin-top: -5px;
        font-size: 1em;
        line-height: 2em;
        color: #FFF;
        font-family: ${props => props.theme.fonts.text};
        margin-left:10px;
    }

    @media (min-width: ${props => props.theme.pageWidth.l}px) {
        max-width: ${props => props.maxWidth};
    }
    
    @media (max-width: ${props => props.theme.pageWidth.xl}px) {
        margin-left: 2rem;
    }
    
    @media (max-width: ${props => props.theme.pageWidth.l}px) {
        display: ${props => props.hideOnSmallerScreens ? 'none' : 'grid'};
        margin: 50px 2rem;
    }

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        grid-template-columns: 1fr;
        margin: 0 auto;

        p {
            margin: 0;
        }
    }
`
const Border = styled.div`
    background:${props => `${props.theme.colors.primary}`};
    width: 1px;
    display:flex;
    justify-content: center;

    &::before{
        position: absolute;
        content: " ";
        display:block;
        width:5px;
        height:5px;
        border-radius: 50%;
        background-color:${props => props.theme.colors.primary};

        @media (max-width: ${props => props.theme.pageWidth.m}px) {
            display: none;
        }
    }

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        display: none;
    }
`

const Text = styled(ReactMarkdown)`
    width: 90%; 

    p {
        width:100%;
        margin-bottom:20px;
    }

    @media (max-width: ${props => props.theme.pageWidth.m}px) {
        //width: 90%;
        margin: auto;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;
    }


    @media (max-width: ${props => props.theme.pageWidth.l}px) {
        display: ${props => props.hide ? 'none' : 'block'};
    }
`
const AlternativeText = styled(Text)`
    display: none;
    @media (max-width: ${props => props.theme.pageWidth.l}px) {
        display: block;
    }    
`;


const TextColumn = (props) => {
    return (
        <TextWrapper hideOnSmallerScreens={props.hideOnSmallerScreens} maxWidth={props.maxWidth} margins={props.margins}>
            <Border></Border>
            <Text source={props.content} hide={props.optionalText}></Text>

            {props.optionalText && 
                <AlternativeText source={props.content + '\n\r' + props.optionalText}></AlternativeText>
            }
        </TextWrapper>
    );
};

export default withTheme(TextColumn);